import { FC, ReactNode, createContext, useContext } from "react";

import { EnrollmentExperienceResponse } from "@/api/types";

const DEFAULT_EXPERIENCE: EnrollmentExperienceResponse = {
  is_premium: false,
} as EnrollmentExperienceResponse;

export const EnrollmentContext = createContext<EnrollmentExperienceResponse>(DEFAULT_EXPERIENCE);

export const EnrollmentProvider: FC<{ children: ReactNode; experienceData: EnrollmentExperienceResponse }> = ({
  children,
  experienceData,
}) => {
  return (
    <EnrollmentContext.Provider value={experienceData}>
      {children}
    </EnrollmentContext.Provider>
  );
};

export const useEnrollmentContext = (): EnrollmentExperienceResponse => useContext(EnrollmentContext);
